import { render, staticRenderFns } from "./TableWithSelectionsCessao.vue?vue&type=template&id=4955b8c9&scoped=true"
import script from "./TableWithSelectionsCessao.vue?vue&type=script&lang=js"
export * from "./TableWithSelectionsCessao.vue?vue&type=script&lang=js"
import style0 from "./TableWithSelectionsCessao.vue?vue&type=style&index=0&id=4955b8c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4955b8c9",
  null
  
)

export default component.exports